import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GenerateClassificationService } from '../../services/generate-classification.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-generate-classification',
  templateUrl: './generate-classification.component.html',
  styleUrl: './generate-classification.component.scss',
})
export class GenerateClassificationComponent implements OnInit, OnDestroy {
  currentActiveTab: string = 'databases';
  selectedDatabase: string = '';
  selectedSchema: string = '';
  selectedTable: string = '';
  tableDescription: string = '';
  tableDescriptionFull: string = '';
  metadataArray: any = [];

  columnDescription: string = '';
  columnDescriptionFull: string = '';

  domain: string = '';
  business_type: string = '';

  displayedColumns: string[] = [
    'select',
    'columnName',
    'snowflakeGlossary',
    'snowflakeDataType',
    'snowflakeTag',
    'atlanGlossary',
    'atlanDataType',
    'atlanTag',
    'columnDescriptionInstruction',
    'action',
  ];
  @ViewChild('descriptionDialog') descriptionDialog!: TemplateRef<any>;
  @ViewChild('columnDescriptionDialog')
  columnDescriptionDialog!: TemplateRef<any>;

  private dialogRef?: MatDialogRef<any>;

  databases: any = [];
  schemas: any = [];
  tables: any = [];
  isLoading: boolean = true;

  enableEditing: boolean = false;
  currentActiveRowIndex: number = -1;
  metadata: any;
  inputDatabaseSearchValue: string = '';
  originalDatabaseList = [''];
  inputSchemaSearchValue: string = '';
  originalSchemaList = [''];
  inputTableSearchValue: string = '';
  originalTableList = [''];

  schemaLoading: boolean = false;
  tableLoading: boolean = false;
  metadataLoading: boolean = false;
  generateDescriptionLoading: boolean = false;
  isAtlanDatabase: boolean = false;
  currentActiveMetadataIndex: number = -1;
  completion_percentage: number = 0;
  selectedTableForDescription: any = null;
  selectedColumnForDescription: any = null;
  private databaseSubscription!: Subscription;
  private schemaSubscription!: Subscription;
  private tableSubscription!: Subscription;
  private metadataSubscription!: Subscription;
  private saveClassificationSubscription!: Subscription;

  constructor(
    public dialog: MatDialog,
    private generateClassificationService: GenerateClassificationService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.originalDatabaseList = [];
    let getAtlanFlag: any = localStorage.getItem('isAtlanDatabase');
    this.isAtlanDatabase = JSON.parse(getAtlanFlag);
    this.databaseSubscription = this.generateClassificationService
      .getDatabase()
      .subscribe({
        next: (response: any) => {
          response = [...new Set(response)];
          this.isLoading = false;
          this.databases = response;
          this.originalDatabaseList = [...this.databases];
        },
        error: (err) => {
          this.isLoading = false;
          this.toastr.error('Failed to fetch databases', 'Error');
        },
      }
      );
  }

  fetchSchemas(database: string) {
    this.completion_percentage = 20;
    this.schemaLoading = true;
    this.schemas = [];
    this.currentActiveTab = 'schemas';
    this.selectedDatabase = database;
    this.schemaSubscription = this.generateClassificationService
      .getSchema(database)
      .subscribe(
        {
          next: (response: any) => {
            this.schemas = response;
            this.originalSchemaList = [...this.schemas];
            this.schemaLoading = false;
          },
          error: (err) => {
            this.schemaLoading = false;
            this.toastr.error('Failed to fetch schemas', 'Error');
          },
        }
      );
  }

  fetchTables(schema: string) {
    this.completion_percentage = 40;
    this.tableLoading = true;
    this.tables = [];
    this.currentActiveTab = 'tables';
    this.selectedSchema = schema;
    this.tableSubscription = this.generateClassificationService
      .getTable(this.selectedDatabase, this.selectedSchema)
      .subscribe(
        {
          next: (response: any) => {
            this.tables = response;
            this.originalTableList = [...this.tables];
            this.tableLoading = false;
          },
          error: (err) => {
            this.tableLoading = false;
            this.toastr.error('Failed to fetch tables', 'Error');
          },
        }
      );
  }

  fetchMetadata(table: string) {
    this.completion_percentage = 60;
    this.currentActiveTab = 'meta';
    this.selectedTable = table;
    this.metadataLoading = true;

    if (this.metadataArray.length > 4) {
      this.toastr.error(
        'You can add maximum 5 tables.',
        'Limit Exceeded!'
      );
      this.metadataLoading = false;
      return;
    }

    for (let item of this.metadataArray) {
      if (this.selectedDatabase == item.database_name && this.selectedSchema == item.schemas[0].schema_name && this.selectedTable == item.schemas[0].tables[0].table_name) {
        this.toastr.error(
          'Table already selected.',
          'Conflict Error!'
        );
        this.metadataLoading = false;
        return;
      }
    }

    this.metadataSubscription = this.generateClassificationService
      .getMetadata({
        isAtlan: this.isAtlanDatabase,
        database_name: this.selectedDatabase,
        schema_name: this.selectedSchema,
        table_name: this.selectedTable,
      })
      .subscribe({
        next: (response: any) => {
          this.metadata = response.data.databases;
          this.metadataLoading = false;
          for (let item of response.data.databases) {
            const keys = Object.keys(item.schemas[0].tables[0].columns);
            let columns = [];
            for (let key of keys) {
              columns.push({
                column_name: key,
                snowflake_metadata:
                  item.schemas[0].tables[0].columns[key].snowflake_metadata,
                atlan_metadata:
                  item.schemas[0].tables[0].columns[key].atlan_metadata,
                column_description_instruction: '',
                checked: true,
              });
            }
            item.checked = true;
            item.schemas[0].tables[0].metaData = columns;
            item.schemas[0].tables[0].table_metadata = {
              domain: '',
              business_type: '',
              user_table_description: '',
            };
            this.metadataArray.push(item);
          }
        },
        error: (err) => {
          this.metadataLoading = false;
          this.toastr.error('Failed to fetch metadata', 'Error');
        },
      });
  }

  checkRow(event: any, row: any, item: any) {
    for (let element of this.metadataArray) {
      if (
        element.database_name == item.database_name &&
        element.schemas[0].schema_name == item.schemas[0].schema_name &&
        element.schemas[0].tables[0].table_name ==
        item.schemas[0].tables[0].table_name
      ) {
        for (let ds of element.schemas[0].tables[0].metaData) {
          if (ds.column_name == row.column_name) {
            row.checked = event.checked;
          }
        }
        const check = element.schemas[0].tables[0].metaData.filter(
          (column: any) => column.checked == false
        );
        if (check.length > 0) {
          element.checked = false;
        } else {
          element.checked = true;
        }
      }
    }
  }

  saveMetadata() {
    if (this.metadataArray.length == 0) {
      this.toastr.error(
        'Please select any table to generate classification',
        'Error'
      );
      return;
    }
    for (let item of this.metadataArray) {
      const checkedColumn = item.schemas[0].tables[0].metaData.filter(
        (column: any) => column.checked == true
      );

      if (checkedColumn.length == 0) {
        this.toastr.error(
          'Please check atleast one column of each table to generate classification',
          'Error'
        );
        return;
      }
    }
    this.completion_percentage = 70;
    this.generateDescriptionLoading = true;
    let payload = [...this.metadataArray];
    let newPayload: any = [];
    for (let item of payload) {
      const dbMatchIndex = newPayload.findIndex(
        (element: any) => item.database_name == element.database_name
      );
      let localItem = { ...item };
      if (dbMatchIndex > -1) {
        const schemaMatchIndex = newPayload[dbMatchIndex].schemas.findIndex(
          (element: any) => item.schemas[0].schema_name == element.schema_name
        );
        if (schemaMatchIndex > -1) {
          const tableMatchIndex = newPayload[dbMatchIndex].schemas[
            schemaMatchIndex
          ].tables.findIndex(
            (element: any) =>
              item.schemas[0].tables[0].table_name == element.table_name
          );

          const filteredColumn = localItem.schemas[0].tables[0].metaData.filter(
            (column: any) => column.checked == true
          );

          let columns: any = {};
          delete localItem.checked;

          for (let el of filteredColumn) {
            columns[el.column_name] =
              localItem.schemas[0].tables[0].columns[el.column_name];

            let ud = localItem.schemas[0].tables[0].metaData.filter(
              (column: any) => column.column_name == el.column_name
            );

            columns[el.column_name].user_instruction =
              ud[0].column_description_instruction;
          }
          delete localItem.schemas[0].tables[0].metaData;

          localItem.schemas[0].tables[0].columns = columns;

          newPayload[dbMatchIndex].schemas[schemaMatchIndex].tables.push(
            localItem.schemas[0].tables[0]
          );
          if (tableMatchIndex > -1) {
          }
        } else {
          const filteredColumn = localItem.schemas[0].tables[0].metaData.filter(
            (column: any) => column.checked == true
          );

          let columns: any = {};
          delete localItem.checked;

          for (let el of filteredColumn) {
            columns[el.column_name] =
              localItem.schemas[0].tables[0].columns[el.column_name];

            let ud = localItem.schemas[0].tables[0].metaData.filter(
              (column: any) => column.column_name == el.column_name
            );

            columns[el.column_name].user_instruction =
              ud[0].column_description_instruction;
          }
          delete localItem.schemas[0].tables[0].metaData;

          localItem.schemas[0].tables[0].columns = columns;
          newPayload[dbMatchIndex].schemas.push(localItem.schemas[0]);
        }
      } else {
        const filteredColumn = localItem.schemas[0].tables[0].metaData.filter(
          (column: any) => column.checked == true
        );
        let columns: any = {};
        delete localItem.checked;

        for (let el of filteredColumn) {
          columns[el.column_name] =
            localItem.schemas[0].tables[0].columns[el.column_name];

          let ud = localItem.schemas[0].tables[0].metaData.filter(
            (column: any) => column.column_name == el.column_name
          );

          columns[el.column_name].user_instruction =
            ud[0].column_description_instruction;
        }
        delete localItem.schemas[0].tables[0].metaData;

        localItem.schemas[0].tables[0].columns = columns;

        newPayload.push(localItem);
      }
    }

    this.saveClassificationSubscription = this.generateClassificationService
      .saveMetadata({
        databases: newPayload,
      })
      .subscribe(
        {
          next: (response: any) => {
            if (response.status == 'success') {
              this.toastr.success('Classification has been generated', 'Success');
              localStorage.setItem(
                'llm_processing',
                JSON.stringify(response.llm_processing)
              );
              localStorage.setItem(
                'metadataArray',
                JSON.stringify(this.metadataArray)
              );
              this.router.navigate(['/output']);
            } else {
              this.toastr.error('Failed to generate classification', 'Error');
            }
            this.generateDescriptionLoading = false;
          },
          error: (err) => {
            this.generateDescriptionLoading = false;
            this.toastr.error('Failed to generate classification', 'Error');
          },
        }
      );
  }

  expandSection(section: any) {
    if (section === 'databases') {
      this.databases = this.originalDatabaseList;
      this.currentActiveTab = 'databases';
    } else if (section === 'schemas') {
      this.schemas = this.originalSchemaList;
      this.currentActiveTab = 'schemas';
    } else if (section === 'tables') {
      this.tables = this.originalTableList;
      this.currentActiveTab = 'tables';
    }
  }

  enableEdit(index: number, element: any, itemIndex: number) {
    this.enableEditing = true;
    this.currentActiveRowIndex = index;
    this.currentActiveMetadataIndex = itemIndex;
  }

  saveItem(index: number, element: any) {
    this.enableEditing = false;
    this.currentActiveRowIndex = -1;
  }

  toggleAllRows(event: any, item: any) {
    for (let element of this.metadataArray) {
      if (
        element.database_name == item.database_name &&
        element.schemas[0].schema_name == item.schemas[0].schema_name &&
        element.schemas[0].tables[0].table_name ==
        item.schemas[0].tables[0].table_name
      ) {
        for (let ds of element.schemas[0].tables[0].metaData) {
          ds.checked = event.checked;
        }
      }
    }
  }

  onInputDatabaseNameChange(event: any) {
    this.inputDatabaseSearchValue = (event.target as HTMLInputElement).value;
    this.databases = [];
    if (this.originalDatabaseList.length > 0) {
      for (let i = 0; i < this.originalDatabaseList.length; i++) {
        if (
          this.originalDatabaseList[i]
            ?.toLowerCase()
            .includes(this.inputDatabaseSearchValue.toLowerCase())
        ) {
          this.databases.push(this.originalDatabaseList[i]);
        }
      }
    }
  }

  onInputSchemaNameChange(event: any) {
    this.inputSchemaSearchValue = (event.target as HTMLInputElement).value;
    this.schemas = [];
    for (let i = 0; i < this.originalSchemaList.length; i++) {
      if (
        this.originalSchemaList[i]
          .toLowerCase()
          .includes(this.inputSchemaSearchValue.toLowerCase())
      ) {
        this.schemas.push(this.originalSchemaList[i]);
      }
    }
  }

  onInputTableNameChange(event: any) {
    this.inputTableSearchValue = (event.target as HTMLInputElement).value;
    this.tables = [];
    for (let i = 0; i < this.originalTableList.length; i++) {
      if (
        this.originalTableList[i]
          .toLowerCase()
          .includes(this.inputTableSearchValue.toLowerCase())
      ) {
        this.tables.push(this.originalTableList[i]);
      }
    }
  }

  deleteTable(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
    metadata: any
  ): void {
    const dialogRef = this.dialog.open(DeleteTableDialog, {
      width: '400px',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmed) {
        const index = this.metadataArray.findIndex(
          (item: any) =>
            item.database_name == metadata.database_name &&
            item.schemas[0].schema_name == metadata.schemas[0].schema_name &&
            item.schemas[0].tables[0].table_name ==
            metadata.schemas[0].tables[0].table_name
        );

        this.metadataArray.splice(index, 1);
        this.toastr.error('Table has been removed', 'Removed');
      } else {
      }
    });
  }

  closeDescriptionDialog(): void {
    this.dialogRef?.close();
    this.selectedColumnForDescription = null;
    this.selectedTableForDescription = null;
  }

  saveDescription(type: any): void {
    // Update the main description with a truncated version
    this.tableDescription =
      this.tableDescriptionFull?.length > 200
        ? this.tableDescriptionFull.substring(0, 197) + '...'
        : this.tableDescriptionFull;

    this.columnDescription =
      this.columnDescriptionFull?.length > 200
        ? this.columnDescriptionFull.substring(0, 197) + '...'
        : this.columnDescriptionFull;

    if (type == 'table') {
      for (let element of this.metadataArray) {
        if (
          element.database_name ==
          this.selectedTableForDescription.database_name &&
          element.schemas[0].schema_name ==
          this.selectedTableForDescription.schemas[0].schema_name &&
          element.schemas[0].tables[0].table_name ==
          this.selectedTableForDescription.schemas[0].tables[0].table_name
        ) {
          element.schemas[0].tables[0].table_metadata.user_table_description =
            this.tableDescription;
        }
      }
    } else if (type == 'column') {
      for (let element of this.metadataArray) {
        if (
          element.database_name ==
          this.selectedTableForDescription.database_name &&
          element.schemas[0].schema_name ==
          this.selectedTableForDescription.schemas[0].schema_name &&
          element.schemas[0].tables[0].table_name ==
          this.selectedTableForDescription.schemas[0].tables[0].table_name
        ) {
          for (let ds of element.schemas[0].tables[0].metaData) {
            if (
              ds.column_name == this.selectedColumnForDescription.column_name
            ) {
              ds.column_description_instruction = this.columnDescription;
            }
          }
        }
      }
    }

    this.dialogRef?.close();
  }

  clearDescription(): void {
    this.tableDescriptionFull = '';
    this.columnDescriptionFull = '';
  }

  openDescriptionDialog(type: any, table: any, column: any): void {
    if (type == 'table') {
      for (let element of this.metadataArray) {
        if (
          element.database_name == table.database_name &&
          element.schemas[0].schema_name == table.schemas[0].schema_name &&
          element.schemas[0].tables[0].table_name ==
          table.schemas[0].tables[0].table_name
        ) {
          this.tableDescriptionFull =
            element.schemas[0].tables[0].table_metadata.user_table_description;
          this.selectedTableForDescription = table;
        }
      }

      this.dialogRef = this.dialog.open(this.descriptionDialog, {
        width: '800px',
        maxWidth: '90vw',
        height: 'auto',
        maxHeight: '90vh',
        disableClose: true,
        panelClass: 'description-dialog-panel',
      });
    } else if (type == 'column') {
      for (let element of this.metadataArray) {
        if (
          element.database_name == table.database_name &&
          element.schemas[0].schema_name == table.schemas[0].schema_name &&
          element.schemas[0].tables[0].table_name ==
          table.schemas[0].tables[0].table_name
        ) {
          for (let ds of element.schemas[0].tables[0].metaData) {
            if (ds.column_name == column.column_name) {
              this.columnDescriptionFull =
                column.column_description_instruction;
              this.selectedTableForDescription = table;
              this.selectedColumnForDescription = column;
            }
          }
        }
      }
      this.dialogRef = this.dialog.open(this.columnDescriptionDialog, {
        width: '800px',
        maxWidth: '90vw',
        height: 'auto',
        maxHeight: '90vh',
        disableClose: true,
        panelClass: 'description-dialog-panel',
      });
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.databaseSubscription) {
      this.databaseSubscription.unsubscribe();
    }
    if (this.schemaSubscription) {
      this.schemaSubscription.unsubscribe();
    }
    if (this.tableSubscription) {
      this.tableSubscription.unsubscribe();
    }
    if (this.metadataSubscription) {
      this.metadataSubscription.unsubscribe();
    }
    if (this.saveClassificationSubscription) {
      this.saveClassificationSubscription.unsubscribe();
    }
  }
}

@Component({
  selector: 'delete-table-dialog',
  templateUrl: 'delete-table-dialog.html',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatCardModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DeleteTableDialog {
  constructor(
    public dialogRef: MatDialogRef<DeleteTableDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close(); // Close without returning data
  }

  onOk(): void {
    const resultData = { confirmed: true, value: 'some data from dialog' };
    this.dialogRef.close(resultData); // Close and return data
  }
}
